import { createSelector } from 'reselect'
import * as R from 'ramda'
import { GetNbProductsOutOfStock } from './stock.types'
import { getProductsInParentScope } from './scope'

export const getNbProductsOutOfStock: GetNbProductsOutOfStock = createSelector(
  getProductsInParentScope,
  R.compose(
    R.length,
    R.filter(R.prop('outOfStock'))
  )
)
